import { SET_CURRENT_ADMIN, GET_ERRORS } from "../actions/types";
import isEmpty from "../validation/is-empty";

const initialState = {
  isAdminAuthenticated: false,
  admin: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_ADMIN:
      return {
        ...state,
        isAdminAuthenticated: !isEmpty(action.payload),
        admin: action.payload
      };
    case GET_ERRORS:
      return {
        ...state
      };
    default:
      return state;
  }
}
